import React, { useContext, useEffect } from "react";
import { Box, Typography, useScreenClass } from "@vp/swan";
import { CloudinaryIcon } from "../../../../components/CloudinaryIcon";
import { useInView } from "react-intersection-observer";
import { ProductBuilderContext } from "../../../../contexts/ProductBuilderContextProvider";
import { PluginDataContext } from "../../../../pluginsInfrastructure/PluginDataContextProvider";
import { getScreenClass } from "../../../../utils/screenClass";

const SatisfactionGuaranteed: React.FC = () => {
  const { isMobile } = getScreenClass(useScreenClass());
  const [_satisfactionGuaranteedRef, isSatisfactionGuaranteedInView] = useInView({
    threshold: 0,
  });

  const { satisfactionGuaranteedInView, setSatisfactionGuaranteedInView } = useContext(
    ProductBuilderContext
  );

  const { pluginData } = useContext(PluginDataContext);
  const satisfactionGuaranteedLabel = pluginData.contentful["satisfactionGuaranteed"];
  const satisfactionGuaranteedImage =
    pluginData.contentful["satisfactionGuaranteedImageOnPageBuilder"];

  useEffect(() => {
    if (isSatisfactionGuaranteedInView !== satisfactionGuaranteedInView) {
      setSatisfactionGuaranteedInView(isSatisfactionGuaranteedInView);
    }
  }, [isSatisfactionGuaranteedInView]);

  return (
    <Box marginTop={isMobile ? "3" : "4"} marginBottom={isMobile ? "0" : "between-subsections"}>
      <Typography
        textAlign="center"
        textColor="subtle"
        fontSize={"small"}
        fontWeight="bold"
        paddingX={"3"}
      >
        <CloudinaryIcon image={satisfactionGuaranteedImage} />
        {satisfactionGuaranteedLabel}
      </Typography>
    </Box>
  );
};

export default SatisfactionGuaranteed;
